import '@babel/polyfill';

(async () => {
  await import(/* webpackChunkName: "home-main" */ '../pages/home/main');
})();
